import { jsx as _jsx } from "react/jsx-runtime";
const Highlight = _ref => {
  let {
    text = '',
    highlight = ''
  } = _ref;
  if (!highlight.trim()) {
    return /*#__PURE__*/_jsx("span", {
      children: text
    });
  }
  const highlightTerms = highlight.split(/\s+/).filter(Boolean);
  const regex = new RegExp("(".concat(highlightTerms.join('|'), ")"), 'gi');
  const parts = text.split(regex);
  return /*#__PURE__*/_jsx("span", {
    children: parts.map((part, index) => regex.test(part) ? /*#__PURE__*/_jsx("span", {
      className: "strong",
      children: part
    }, index) : part)
  });
};
export default Highlight;
//# sourceMappingURL=highLight.js.map